const lightGallery = window.lightGallery;
const lgZoom = window.lgZoom;

document.addEventListener("DOMContentLoaded", () => {
  if (!lightGallery) {
    return;
  }

  const galler = document.querySelectorAll(".gallery-slider-checker");


  galler.forEach((element, index) => {
    console.log(`gallery-place-global-${index + 1}`);
    lightGallery(document.getElementById(`gallery-place-global-${index + 1}`), {
      speed: 500,
      plugins: [lgZoom],
      mobileSettings: {
        controls: true,
        showCloseIcon: true,
        download: false,
      },
    });
  });

  const dropdownOptions = document.querySelectorAll(".gallery-fitler-data");
  const galleries = document.querySelectorAll(".gallery-slider");
  const viewAllBtn = document.getElementById("view-all-btn");
  const galleryTitle = document.querySelector(".gallery-title-view h3 span");
  const textGallery = document.querySelectorAll(".active-gallery-text");

  // Function to update the active gallery text
  function updateActiveGalleryText(selectedSelection) {
    textGallery.forEach((textElement) => {
      if (textElement.dataset.selection === selectedSelection) {
        textElement.classList.add("active");
      } else {
        textElement.classList.remove("active");
      }
    });

    // Update the URL with the selected data-text
    const currentURL = new URL(window.location.href);
    currentURL.searchParams.set("text", selectedSelection);
    window.history.replaceState({}, "", currentURL);
  }

  // Function to update the active gallery
  function updateActiveGallery(selectedGallery) {
    galleries.forEach((gallery) => {
      console.log(gallery.dataset.filter, selectedGallery);
      if (gallery.dataset.filter === selectedGallery) {
        gallery.classList.add("actived");
         let innerItems = gallery.querySelectorAll(".gallery-image")
            console.log(innerItems)
           gsap.fromTo(innerItems,{alpha:0},{alpha:1, ease:"power2.out", stagger:0.2,duration:0.5})

      } else {
        gallery.classList.remove("actived");
      }
    });

   
    // Update the URL query string
    const currentURL = new URL(window.location.href);
    currentURL.searchParams.set("gallery", selectedGallery);
    window.history.replaceState({}, "", currentURL);
  }

  // Function to handle URL on page load
  function loadGalleryFromURL() {
    const currentURL = new URL(window.location.href);
    const selectedGallery = currentURL.searchParams.get("gallery");
    const selectedText = currentURL.searchParams.get("text");

    if (selectedGallery) {
      updateActiveGallery(selectedGallery);
      const activeGallery = document.querySelector(
        ".gallery-slider-checker.gallery-slider.actived"
      );
      const innerItems = activeGallery?.querySelectorAll(".gallery-image") || [];
      console.log(innerItems);
      gsap.fromTo(innerItems, { alpha: 0 }, { alpha: 1, ease: "power2.out", stagger: 0.2, duration: 0.5 });

      if (activeGallery && galleryTitle) {
        const activeGalleryHeading = activeGallery.querySelector("h6");
        const activeGalleryText = activeGalleryHeading ? activeGalleryHeading.textContent.trim() : "";
        galleryTitle.innerHTML = activeGalleryText;
      }
    }

    if (selectedText) {
      updateActiveGalleryText(selectedText);
    }
  }

  // Dropdown click listener
  dropdownOptions.forEach((option) => {
    option.addEventListener("click", () => {
      const selectedGallery = option.dataset.filter;
      const selectedId = option.dataset.selection;
      const selectedText = option.dataset.text; // Add data-text here

      console.log(option.dataset.filter, selectedId);
      updateActiveGallery(selectedGallery);
      updateActiveGalleryText(selectedId); // Pass selectedText to updateActiveGalleryText
    });
  });

  // View All Button listener
  if (viewAllBtn) {
    viewAllBtn.addEventListener("click", (event) => {
      event.preventDefault();
      galleries.forEach((gallery) => {
        gallery.classList.add("actived");
      });

      // Clear the URL query string
      const currentURL = new URL(window.location.href);
      currentURL.searchParams.delete("gallery");
      currentURL.searchParams.delete("text"); // Clear the text param as well
      window.history.replaceState({}, "", currentURL);
    });
  }

  // Load the correct gallery and text on page load based on the query string
  loadGalleryFromURL();

  document.addEventListener("click", function (event) {
    const dropdown = document.querySelector(".gallery-filter");

    if (dropdown && dropdown.classList.contains("active") && !dropdown.contains(event.target)) {
        dropdown.classList.remove("active");
    }


});
 let innerItems = document.querySelectorAll(".gallery-slider-checker.actived .gallery-image")
     
  gsap.to(".gallery-spinner",{
    alpha:0,
    display:"none",
    ease:"power2.out",
    onComplete:()=>{
      gsap.fromTo(innerItems,{alpha:0},{alpha:1, ease:"power2.out", stagger:0.2,duration:0.5})

    }
  })

        


});
